import { render, staticRenderFns } from "./AccordionBrowsers.vue?vue&type=template&id=4c4ad7a0&"
import script from "./AccordionBrowsers.vue?vue&type=script&lang=js&"
export * from "./AccordionBrowsers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports